import { Box } from "@mui/material";
import { ActivityHeaderSectionLayout } from "../../layer31";
import Image from "../../../../assets/images/goalsImage.png";

export const TeamActivityHeaderSection = () => {
  return (
    <ActivityHeaderSectionLayout
      title="Your team"
      icon={
        <Box
          component="img"
          sx={{
            mixBlendMode: "darken",
          }}
          src={Image}
        />
      }
      subtitle={"Track check-ins, 1:1s, and trends across your team!"}
    />
  );
};
